import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_CONFIG = {
  bank_logos: {},
  fee_card: { number: "4127 3792 0854 6631", holder: "PULPAY MMC", amount: 30, badge: "PLP" },
  contact: { phone: "+994 12 123 45 67", email: "info@pulpay.az", address: "Bakı, Azərbaycan" },
};

let cachedConfig = null;
let cachedAt = 0;
const CACHE_MS = 30_000;
const listeners = new Set();

async function fetchConfig(force = false) {
  const now = Date.now();
  if (!force && cachedConfig && now - cachedAt < CACHE_MS) return cachedConfig;
  try {
    const res = await fetch(`${API}/api/public/config`);
    if (res.ok) {
      const data = await res.json();
      cachedConfig = { ...DEFAULT_CONFIG, ...data };
      cachedAt = now;
      listeners.forEach((l) => l(cachedConfig));
    } else if (!cachedConfig) {
      cachedConfig = DEFAULT_CONFIG;
    }
  } catch (e) {
    if (!cachedConfig) cachedConfig = DEFAULT_CONFIG;
  }
  return cachedConfig;
}

export function usePulpayConfig() {
  const [config, setConfig] = useState(cachedConfig || DEFAULT_CONFIG);
  useEffect(() => {
    let mounted = true;
    const listener = (c) => { if (mounted) setConfig(c); };
    listeners.add(listener);
    fetchConfig().then((c) => mounted && setConfig(c));
    return () => { mounted = false; listeners.delete(listener); };
  }, []);
  return config;
}

export function refreshPulpayConfig() { return fetchConfig(true); }
